<template>
  <div class="text-14 text-bold">
    <div class="mb-4">
      <span
        v-if="tradingInfo.tradingSubmitStatusCd === 1"
        class="draft text-20"
      >
        Draft
      </span>
    </div>
    <div class="tradingName mb-1">
      <span class="mr-1 text-gray-600"> {{ $t('Label.Trading Name') }}: </span>
      <span class="copyable">
        {{ tradingInfo.tradingName }}
      </span>
    </div>

    <div class="tradingOwnerName mb-1">
      <span class="mr-1 text-gray-600">{{ $t('Label.Owner') }}: </span>
      <span class="copyable">
        {{ tradingInfo.ownerCompanyName }}
      </span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    tradingInfo: {
      type: Object,
      require: true,
    },
  },
  setup() {},
});
</script>

<style scoped>
.draft {
  background-color: #6d717c;
  color: #fff;
  border-radius: 4px;
  padding: 3px 12px;
}
</style>
